// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from './http/axios'
import VantGreen from 'vant-green'
import axiosNtLoading from 'axios'
import 'vant-green/lib/index.css'
import VueClipboard from 'vue-clipboard2'
Vue.prototype.axiosNtLoading = axiosNtLoading // 无loading走封装，少用

Vue.use(VantGreen)
Vue.use(VueClipboard)
// import elementUi from 'element-ui'
Vue.prototype.axios = axios
Vue.config.productionTip = false
// Vue.use(elementUi)
/* eslint-disable no-new */

/* 格式化日期 使用方法：this.$formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss') */
Vue.prototype.$formatDate = (date, format) => {
  var o = {
    'M+': date.getMonth() + 1, // month
    'd+': date.getDate(), // day
    'h+': date.getHours(), // hour
    'm+': date.getMinutes(), // minute
    's+': date.getSeconds(), // second
    'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
    S: date.getMilliseconds()
  }
  if (/(y+)/.test(format)) {
    format = format.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return format
}

new Vue({
  el: '#app',
  router,
  axios,
  axiosNtLoading,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js